import { Link as GatsbyLink } from "gatsby"
import React from "react"
import { normalizePath } from "../../lib/urls"

// Anything that isn't a site-relative path is passed through untouched —
// normalising an absolute URL would mangle it into "/https:/example.com".
const isExternal = to =>
  typeof to !== "string" ||
  /^([a-z][a-z0-9+.-]*:|\/\/)/i.test(to) ||
  to.startsWith("#")

const buildTo = (to, lang) => {
  if (isExternal(to)) return to

  const prefix = lang && lang !== "en" ? `/${lang}` : ""
  // Normalise the path only; keep any ?query / #hash suffix intact.
  // The explicit separator matters: a `to` authored without a leading slash
  // would otherwise glue onto the prefix as "/esbirth-control-options/...".
  // normalizePath collapses the duplicate when `to` does start with one.
  const [, pathPart, suffix] = /^([^?#]*)(.*)$/.exec(to)
  return `${normalizePath(`${prefix}/${pathPart}`)}${suffix}`
}

const Link = ({ to, lang, children, ...restProps }) => {
  return (
    <GatsbyLink to={buildTo(to, lang)} {...restProps}>
      {children}
    </GatsbyLink>
  )
}

export default Link
